<template>
    <div class="container">
        <Header></Header>
        <router-view class="main-wrap"></router-view>
        <Footer :class="[$route.name]"></Footer>
    </div>
</template>

<script>
import Header from '../../components/Common/Header.vue'
import Footer from '../../components/Common/Footer.vue'
export default {
    data(){return{
    }},
    components:{
        Header,
        Footer,
    },
    mounted: function () {
        
    },
    created(){
    },
    methods:{
        
    }   
}
</script>
